import { render, staticRenderFns } from "./Snat.vue?vue&type=template&id=3b9f12d0"
import script from "./Snat.vue?vue&type=script&lang=js"
export * from "./Snat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports